import Package from './Package';

export const REALTOR_PACKAGE_ID_PREFIX = 'realtors_package_id_';

export const PACKAGE_PERIODS_NAMES = {
  TWENTY_ONE_DAYS: 'TWENTY_ONE_DAYS',
  MONTH: 'MONTH',
  TREE_MONTHS: 'TREE_MONTHS',
  YEAR: 'YEAR'
};

export const PACKAGE_PERIODS_TITLE = [
  'regular',
  'advanced',
  'upgraded',
  'premium'
];

export const PROMOTIONS = {
  PROPERTIES: 'properties',
  HIGHLIGHTS: 'highlight',
  AUTO_JUMPS: 'autojump',
  TOP_AD: 'top_promotion'
};

export const PACKAGE_FEATURES = {
  PROPERTIES: PROMOTIONS.PROPERTIES,
  UNLIMITED_AGENTS: 'unlimited_agents',
  VIRTUAL_NUMBERS: 'virtual_numbers',
  COMPANY_PAGE: 'page',
  HIGHLIGHTS: PROMOTIONS.HIGHLIGHTS,
  AUTO_JUMPS: PROMOTIONS.AUTO_JUMPS,
  TOP_AD: PROMOTIONS.TOP_AD
};

export const PACKAGE_FEATURES_ORDER = [
  PACKAGE_FEATURES.PROPERTIES,
  PACKAGE_FEATURES.UNLIMITED_AGENTS,
  PACKAGE_FEATURES.VIRTUAL_NUMBERS,
  PACKAGE_FEATURES.COMPANY_PAGE,
  PACKAGE_FEATURES.HIGHLIGHTS,
  PACKAGE_FEATURES.AUTO_JUMPS,
  PACKAGE_FEATURES.TOP_AD
];

export const PACKAGE_PERIODS = {
  [PACKAGE_PERIODS_NAMES.TWENTY_ONE_DAYS]: {
    periodName: PACKAGE_PERIODS_NAMES.TWENTY_ONE_DAYS,
    value: 21,
    label: 'treeWeeks',
    multiplier: 1
  },
  [PACKAGE_PERIODS_NAMES.MONTH]: {
    periodName: PACKAGE_PERIODS_NAMES.MONTH,
    value: 30,
    label: 'month',
    multiplier: 1
  },
  [PACKAGE_PERIODS_NAMES.TREE_MONTHS]: {
    periodName: PACKAGE_PERIODS_NAMES.TREE_MONTHS,
    value: 90,
    label: 'threeMonth',
    multiplier: 3
  },
  [PACKAGE_PERIODS_NAMES.YEAR]: {
    periodName: PACKAGE_PERIODS_NAMES.YEAR,
    value: 365,
    label: 'year',
    multiplier: 12
  }
};

const buildPackageFeatures = (
  adsQuantity,
  unlimitedAgents,
  virtualNumbers,
  companyPage,
  highlightsQuantity,
  autojumpsQuantity,
  topPromotionQuantity
) => ({
  [PACKAGE_FEATURES.PROPERTIES]: adsQuantity,
  [PACKAGE_FEATURES.UNLIMITED_AGENTS]: unlimitedAgents,
  [PACKAGE_FEATURES.VIRTUAL_NUMBERS]: virtualNumbers,
  [PACKAGE_FEATURES.COMPANY_PAGE]: companyPage,
  [PACKAGE_FEATURES.HIGHLIGHTS]: highlightsQuantity,
  [PACKAGE_FEATURES.AUTO_JUMPS]: autojumpsQuantity,
  [PACKAGE_FEATURES.TOP_AD]: topPromotionQuantity
});

export const PACKAGES_DESCRIPTION = {
  10: {
    [PACKAGE_PERIODS_NAMES.MONTH]: {
      priceForAdPerMonth: 24.9,
      features: buildPackageFeatures(
        10,
        true,
        true,
        false,
        0,
        0,
        0
      )
    },
    [PACKAGE_PERIODS_NAMES.YEAR]: {
      priceForAdPerMonth: 19.9,
      oldPriceForAdPerMonth: 24.9,
      features: buildPackageFeatures(
        10,
        true,
        true,
        true,
        0,
        0,
        0
      )
    }
  },
  25: {
    [PACKAGE_PERIODS_NAMES.MONTH]: {
      priceForAdPerMonth: 17.96,
      features: buildPackageFeatures(
        25,
        true,
        true,
        false,
        0,
        0,
        0
      )
    },
    [PACKAGE_PERIODS_NAMES.YEAR]: {
      priceForAdPerMonth: 14.36,
      oldPriceForAdPerMonth: 17.96,
      features: buildPackageFeatures(
        25,
        true,
        true,
        true,
        1,
        0,
        0
      )
    }
  },
  50: {
    [PACKAGE_PERIODS_NAMES.MONTH]: {
      priceForAdPerMonth: 13.98,
      features: buildPackageFeatures(
        50,
        true,
        true,
        false,
        1,
        2,
        0
      )
    },
    [PACKAGE_PERIODS_NAMES.YEAR]: {
      priceForAdPerMonth: 11.18,
      oldPriceForAdPerMonth: 13.98,
      features: buildPackageFeatures(
        50,
        true,
        true,
        true,
        2,
        5,
        0
      )
    }
  },
  100: {
    [PACKAGE_PERIODS_NAMES.MONTH]: {
      priceForAdPerMonth: 11.99,
      features: buildPackageFeatures(
        100,
        true,
        true,
        false,
        2,
        3,
        0
      )
    },
    [PACKAGE_PERIODS_NAMES.YEAR]: {
      priceForAdPerMonth: 9.59,
      oldPriceForAdPerMonth: 11.99,
      features: buildPackageFeatures(
        100,
        true,
        true,
        true,
        5,
        10,
        1
      )
    }
  }
};

const POSSIBLE_ADS_COUNT = ['10', '25', '50', '100'];

export const getAdsCountValues = POSSIBLE_ADS_COUNT.map(it => ({ value: it, label: it }));

export const realtorPackagePeriods = [PACKAGE_PERIODS.MONTH, PACKAGE_PERIODS.YEAR];

export const getFormattedRealtorPackagePeriods = (translate) => realtorPackagePeriods
  .map(({ value, label }) => ({ value, label: translate(`${label}ly`) }));

const buildPackage = (index, id, properties, period) => ({
  index,
  id,
  properties,
  period
});

const possiblePackages = [
  buildPackage(0, 'primary_1', 10),
  buildPackage(1, 'primary_2', 25),
  buildPackage(2, 'primary_3', 50),
  buildPackage(3, 'primary_4', 100)
];

export const realtorPackages = possiblePackages.map(item => new Package(item));
